import { _sharedReducerSW, _sharedStateSW } from "@/shared/store/sw/reducer";

export const initialState = _sharedStateSW;

const reducer = (state = initialState, action) => {
  return _sharedReducerSW(state, action);
};

export default reducer;
